import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      "hide-details": "auto",
      placeholder: "Search for a number",
      "append-icon": "fa-search",
      clearable: ""
    },
    on: {
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      solo: "",
      "hide-details": "auto",
      items: _vm.pagingLimitsChoices
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.creditNoteCount
    }
  })], 1)])]), _c("div", {
    staticClass: "list-container"
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --no-hover",
    attrs: {
      headers: _vm.headers,
      items: _vm.items,
      "items-per-page": +_vm.formSearch.paging.limits,
      loading: _vm.isLoading,
      "loading-text": "Loading... Please wait",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.numberLabel",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.customerNumberLabel) + " ")];
      }
    }, {
      key: "item.fromOrderInvoiceNumber",
      fn: function fn(_ref2) {
        var _item$fromOrder;
        var item = _ref2.item;
        return [(_item$fromOrder = item.fromOrder) !== null && _item$fromOrder !== void 0 && _item$fromOrder.id ? _c("router-link", {
          staticClass: "router-link",
          attrs: {
            to: _vm.orderDetails(item.fromOrder.id)
          }
        }, [_vm._v(" " + _vm._s(item.fromOrder.customerDisplayReferenceOrder) + " ")]) : _vm._e()];
      }
    }, {
      key: "item.totalAmountCurrency",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(item.totalAmountCurrency), " ").concat(_vm.getSymbolCurrency(item.initialCurrency))) + " ")];
      }
    }, {
      key: "item.remaining.amountCurrency",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.remaining.amountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(item.initialCurrency)) + " ")];
      }
    }, {
      key: "item.url",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "table-actions"
        }, [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary",
          attrs: {
            rounded: "",
            loading: item.isLoadingFile
          },
          on: {
            click: function click($event) {
              return _vm.getCnFile(item);
            }
          }
        }, [_c(VIcon, {
          staticClass: "fas fa-download mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Download ")], 1)], 1)];
      }
    }], null, true)
  })], 1), _vm.hasResult ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("Paging", {
    attrs: {
      numberOfPages: _vm.numberOfPages,
      currentPage: +_vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.search
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("Index", {
    attrs: {
      currentPage: +_vm.formSearch.paging.currentPage,
      limits: +_vm.formSearch.paging.limits,
      totalNumber: _vm.creditNoteCount
    }
  })], 1)])]) : _vm._e(), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };